class LocalizationForm extends HTMLElement {
  connectedCallback() {
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      inputLang: this.querySelector('input[name="language_code"]'),
    };

    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    this.elements.inputLang.value = event.currentTarget.dataset.lang;

    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);
